import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));

const loadGTag = () => {
  const script = document.createElement('script');
  script.src = 'https://www.googletagmanager.com/gtag/js?id=G-RN2K2KC7JK';
  script.async = true;
  document.body.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  function gtag() { window.dataLayer.push(arguments); }
  gtag('js', new Date());
  gtag('config', 'G-RN2K2KC7JK');

  return () => {
    document.body.removeChild(script);
  };
};

root.render(
  <React.StrictMode>
    <App loadGTag={loadGTag} />
  </React.StrictMode>
);

reportWebVitals();
